import { breakpoint } from 'utility/breakpoints'
import { getParameterFromUrl } from 'utility/helpers'
import { lenisScroll } from 'utility/smooth-scroll'

const tabs = {
  init(): void {
    document.querySelectorAll<HTMLElement>('.tabs').forEach((target: HTMLElement) => {
      this.handleTabs(target)
    })
  },

  handleTabs(target): void {
    const el = {
      buttons: target.querySelectorAll('.tabs__button'),
      listPage: document.querySelector('.list-page'),
      productsPage: document.querySelector('.products-page'),
      searchModal: document.querySelector('.search'),
      searchPage: document.querySelector('.search-page'),
    }

    const method = {
      init(): void {
        // Regular tabs behaviour

        method.toggleTabOnHashChange(null)
        window.addEventListener('hashchange', method.toggleTabOnHashChange)

        // Search modal tabs behaviour

        el.buttons.forEach((button) => {
          if (!button.href.includes('#tab:')) {
            button.addEventListener('click', (event) => {
              method.toggleTab(button, event, true)
            })
          }
        })

        // Additional functionality for tabs on Products page - injecting page parameter into URL + modyfiying pagination

        if (el.productsPage) {
          el.buttons.forEach((button) => {
            if (button.href.includes('#tab:')) {
              const collection = getParameterFromUrl(new URL(button.href), 'collection')
              const hash = button.href.split('#')[1]

              button.href = !collection ? `/hudvorur/?page=1#${hash}` : `/hudvorur/?collection=${collection}&page=1#${hash}`
            }
          })

          el.buttons.forEach((button) => {
            if (button.href.includes('#tab:')) {
              const tabsContent = document.querySelector(`.tabs-content[aria-labelled-by='${button.id}']`)
              const pagination = tabsContent.querySelector('.pagination')

              if (pagination) {
                pagination.querySelectorAll('.pagination__button').forEach((button: HTMLAnchorElement) => {
                  const collection = getParameterFromUrl(new URL(window.location.href), 'collection')
                  const page = getParameterFromUrl(new URL(button.href), 'page')
                  const hash = button.href.split('#')[1]

                  button.href = !collection ? `/hudvorur/?page=${page}#${hash}` : `/hudvorur/?collection=${collection}&page=${page}#${hash}`
                })
              }
            }
          })

          // el.productsPage.querySelectorAll('.tabs-content').forEach((tabsContent) => {
          //   const pagination = tabsContent.querySelector('.pagination')

          //   console.log(pagination)
          // })
        }

        // Removing search query from URL when switching tabs (used on Products page) - obsolete

        // el.buttons.forEach((button) => {
        //   button.addEventListener('click', () => {
        //     if (window.location.search && window.location.hash !== button.getAttribute('href')) {
        //       setTimeout(() => {
        //         window.location.search = ''
        //       }, 12)
        //     }
        //   })
        // })
      },

      handleScrolling: () => {
        // Edge case if the search modal is open

        if (el.searchModal.classList.contains('search--active')) {
          setTimeout(() => {
            el.searchModal.querySelector('.search__results').scrollTop = 0
          }, 1)

          return
        }

        // Different scroll behaviours for different pages

        if (!lenisScroll) {
          return
        }

        if (window.scrollY > 123) {
          if (el.listPage) {
            lenisScroll.scrollTo(el.listPage.querySelector('.list-page__column--right'), {
              offset: window.innerWidth < breakpoint.tablet ? -30 : -40,
            })
          }

          if (el.productsPage) {
            lenisScroll.scrollTo(el.productsPage.querySelector('.products-page__dropdown'), {
              offset:
                el.productsPage.querySelector<HTMLElement>('.products-page__dropdown').offsetHeight -
                (window.innerWidth < breakpoint.tablet ? 30 : 40),
            })
          }

          if (el.searchPage) {
            lenisScroll.scrollTo(el.searchPage.querySelector('.search-page__column--search'), {
              offset:
                window.innerWidth < breakpoint.tablet ? el.searchPage.querySelector<HTMLElement>('.search-page__column--search').offsetHeight : -40,
            })
          }
        } else {
          lenisScroll.scrollTo(window.scrollY)
        }
      },

      toggleTab(button, event, preventDefault = false): void {
        if (preventDefault) {
          event.preventDefault()
        }

        const currentTabsContent = document.querySelector(`.tabs-content[id='${button.href.split('#')[1]}-tab']`)

        el.buttons.forEach((button) => {
          button.classList.remove('tabs__button--active')
          button.ariaExpanded = 'false'
        })

        currentTabsContent.parentElement.querySelectorAll('.tabs-content').forEach((tabsContent) => {
          tabsContent.classList.remove('tabs-content--active')
        })

        button.classList.add('tabs__button--active')
        button.ariaExpanded = 'true'
        currentTabsContent.classList.add('tabs-content--active')

        method.handleScrolling()
      },

      toggleTabOnHashChange(event): void {
        el.buttons.forEach((button) => {
          if (button.href.includes('#tab:')) {
            // Switching between tabs

            if (button.getAttribute('href').includes(window.location.hash)) {
              method.toggleTab(button, event)
            }

            // Opening first tab if no hash

            if (window.location.hash === '') {
              method.toggleTab(el.buttons[0], event)
            }
          }
        })
      },
    }

    method.init()
  },
}

export default tabs
